import React, { useState } from 'react'
import { useTheme } from '../hooks/useTheme'

const TooltipComponent = ({
  placement = 'right',
  children,
  title = '',
  style = {}
}) => {
  const [isHovered, setIsHovered] = useState(false)
  const theme = useTheme()
  const arrowBorder =
    theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.9)' : '#616161'

  const wrapperStyles = {
    position: 'relative',
    display: 'inline-block',
    ...style
  }

  const tooltipStyles = {
    visibility: isHovered ? 'visible' : 'hidden',
    width: 'max-content',
    maxWidth: '150px',
    backgroundColor:
      theme.palette.mode === 'light' ? theme.palette.common.black : '#616161',
    color: theme.palette.common.white,
    textAlign: 'center',
    borderRadius: '5px',
    padding: '6px 8px',
    position: 'absolute',
    zIndex: 99999,
    opacity: isHovered ? 1 : 0,
    transition: 'opacity 0.3s, visibility 0.3s',
    fontSize: '11px',
    whiteSpace: 'normal',
    wordWrap: 'break-word',
    ...(placement === 'right' && {
      top: '50%',
      left: 'calc(100% + 10px)',
      transform: 'translateY(-50%)'
    }),
    ...(placement === 'left' && {
      top: '50%',
      right: 'calc(100% + 10px)',
      transform: 'translateY(-50%)'
    }),
    ...(placement === 'top' && {
      bottom: 'calc(100% + 10px)',
      left: '50%',
      transform: 'translateX(-50%)'
    }),
    ...(placement === 'bottom' && {
      top: 'calc(100% + 10px)',
      left: '50%',
      transform: 'translateX(-50%)'
    })
  }

  const arrowStyles = {
    position: 'absolute',
    width: 0,
    height: 0,
    borderStyle: 'solid',
    ...(placement === 'right' && {
      top: '50%',
      left: '-5px',
      marginTop: '-5px',
      borderWidth: '5px 5px 5px 0',
      borderColor: `transparent ${arrowBorder} transparent transparent`
    }),
    ...(placement === 'left' && {
      top: '50%',
      right: '-5px',
      marginTop: '-5px',
      borderWidth: '5px 0 5px 5px',
      borderColor: `transparent transparent transparent ${arrowBorder} `
    }),
    ...(placement === 'top' && {
      bottom: '-5px',
      left: '50%',
      marginLeft: '-5px',
      borderWidth: '5px 5px 0 5px',
      borderColor: `${arrowBorder}  transparent transparent transparent`
    }),
    ...(placement === 'bottom' && {
      top: '-5px',
      left: '50%',
      marginLeft: '-5px',
      borderWidth: '0 5px 5px 5px',
      borderColor: `transparent transparent ${arrowBorder}  transparent`
    })
  }

  return (
    <div
      style={wrapperStyles}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      role='tooltip'
    >
      {children}
      {title && (
        <span style={tooltipStyles}>
          <span style={arrowStyles} />
          {title}
        </span>
      )}
    </div>
  )
}

export default TooltipComponent

TooltipComponent.displayName = 'TooltipComponent'
